import { createContext, useContext } from 'react';

import { AnalyticsEvent } from '../product';

export const AmplitudeContext = createContext<{ recordEvent: (event: AnalyticsEvent) => Promise<void> } | undefined>(
    undefined
);

export const useAmplitude = () => {
    const context = useContext(AmplitudeContext);

    if (context === undefined) {
        throw new Error('useAmplitude mist be used within a AmplitudeProvider');
    }
    return context;
};
